import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { OrganizationService } from 'src/app/private/services/organization.services';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-delete-campus',
  imports: [SharedModule],
  templateUrl: './delete-campus.component.html',
  styleUrl: './delete-campus.component.scss'
})
export class DeleteCampusComponent {
  @Input() orgId: string = ''; // Organization ID passed from the parent component
  @Input() campusDataToEdit: any = ''; // Campus ID passed from the parent component
  @Output() close = new EventEmitter<void>();
  campusNamae: string = ''; // Campus name to be displayed in the confirmation dialog
  @Output() reload = new EventEmitter<void>(); // Event emitter to notify parent component for reloading data

  constructor(
    private orgService: OrganizationService,
    private messageService: MessageService
  ) {
    // Initialize the campus name with the name of the campus to be deleted
    this.campusNamae = this.campusDataToEdit.name;
  }

  isLoading: boolean = false; // Loading state for the form submission
  handleCloseDialog() {
    this.close.emit();
  }


  handleDeleteCampus() {
    this.isLoading = true; // Set loading state to true
    const payload = {
      organization_id: this.orgId,
      campus_id: this.campusDataToEdit.id // Use the campus ID passed from the parent component
    };
    this.orgService.deleteCampus(payload).subscribe(
      (response) => {
        this.isLoading = false; // Reset loading state
        this.close.emit(); // Emit close event to notify parent component
        this.reload.emit(); // Emit reload event to notify parent component for reloading data
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Campus deleted successfully!'
        });
      },
      (error) => {
        console.error('Error deleting campus:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to delete campus!'
        });

        this.isLoading = false; // Reset loading state on error
      }
    );
  }
}
